var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kst-layout-navbar-info-avatar ml-4 mr-1"},[(_vm.isDefault)?[_c('kst-image',{attrs:{"is-public":"","company-default-img":""}})]:[_c('kst-image',{attrs:{"size-auto":"","border-off":"","hide-preview":"","read-only":"","thumbnail":"","src":_vm.companyImage}})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }